import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2, ClipboardList, Ruler, LineChart, Salad, FileCheck, Briefcase, BoxIcon } from 'lucide-react';
interface Module {
  title: string;
  icon: BoxIcon;
  items: string[];
}
const modules: Module[] = [{
  title: 'Primera Consulta y Anamnesis Nutricional',
  icon: ClipboardList,
  items: ['Ficha de admisión completa del paciente nuevo', 'Anamnesis nutricional detallada (hábitos, antecedentes, historial)', 'Consentimiento informado listo para firmar']
}, {
  title: 'Evaluación Antropométrica',
  icon: Ruler,
  items: ['Registro de peso, talla y circunferencias corporales', 'Cálculo automático de IMC y porcentaje de grasa', 'Evaluación de composición corporal por segmento']
}, {
  title: 'Evolución Clínica y Seguimiento',
  icon: LineChart,
  items: ['Ficha de evolución por consulta lista para completar', 'Registro de adherencia al plan y síntomas reportados', 'Gráfico automático de progreso de peso y medidas']
}, {
  title: 'Planes Alimentarios',
  icon: Salad,
  items: ['Plantilla de plan semanal personalizado por objetivo', 'Calculadora automática de calorías y macronutrientes', 'Lista de equivalencias y porciones por grupo alimentario']
}, {
  title: 'Informes y Obras Sociales',
  icon: FileCheck,
  items: ['Modelo de informe nutricional profesional listo para completar', 'Plantillas específicas para presentación ante obras sociales', 'Resumen de evolución para derivaciones y contra-referencias médicas']
}, {
  title: 'Gestión del Consultorio',
  icon: Briefcase,
  items: ['Registro de turnos, pacientes activos e inactivos', 'Control de honorarios e ingresos mensuales', 'Planilla de seguimiento de agenda semanal']
}];
export function Modules() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);
  return <section className="py-20 bg-gray-50" data-id="element-122">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-125">
            Qué incluye el NutriPro Kit
          </h2>
        </div>

        <div className="space-y-4" data-id="element-126">
          {modules.map((mod, index) => {
          const isExpanded = expandedIndex === index;
          const Icon = mod.icon;
          return <div key={index} className={`bg-white rounded-xl border overflow-hidden transition-all duration-300 ${isExpanded ? 'border-nutri-medium shadow-md ring-1 ring-nutri-medium/20' : 'border-gray-200 hover:border-nutri-mint/50'}`} data-id="element-127">
                <button onClick={() => setExpandedIndex(isExpanded ? null : index)} className={`w-full px-5 py-4 flex items-center justify-between text-left focus:outline-none transition-colors ${isExpanded ? 'bg-nutri-mint/10' : 'bg-white hover:bg-gray-50'}`} data-id="element-128">
                  <div className="flex items-center gap-4" data-id="element-129">
                    <div className="relative flex-shrink-0" data-id="element-130">
                      <div className={`w-14 h-14 rounded-2xl flex items-center justify-center transition-colors ${isExpanded ? 'bg-nutri-medium text-white shadow-md shadow-nutri-medium/30' : 'bg-nutri-mint/20 text-nutri-dark'}`} data-id="element-131">
                        <Icon size={26} strokeWidth={2} data-id="element-132" />
                      </div>
                      <span className={`absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center text-xs font-extrabold border-2 border-white shadow-sm ${isExpanded ? 'bg-nutri-cta text-white' : 'bg-nutri-dark text-white'}`} data-id="element-133">
                        {index + 1}
                      </span>
                    </div>
                    <div data-id="element-134">
                      <span className="block text-xs font-bold uppercase tracking-wider text-nutri-medium mb-0.5" data-id="element-135">
                        Tomo {index + 1}
                      </span>
                      <span className={`block font-bold text-base md:text-lg leading-tight ${isExpanded ? 'text-nutri-dark' : 'text-gray-800'}`} data-id="element-136">
                        {mod.title}
                      </span>
                    </div>
                  </div>
                  <ChevronDown className={`transition-transform duration-300 flex-shrink-0 ml-2 ${isExpanded ? 'rotate-180 text-nutri-medium' : 'text-gray-400'}`} size={24} data-id="element-137" />
                </button>

                <AnimatePresence data-id="element-138">
                  {isExpanded && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-139">
                      <div className="px-5 pb-6 pt-4 border-t border-nutri-mint/20 bg-white" data-id="element-140">
                        <ul className="space-y-3 pl-[4.5rem]" data-id="element-141">
                          {mod.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-600" data-id="element-142">
                              <CheckCircle2 className="text-nutri-medium flex-shrink-0 mt-0.5" size={18} data-id="element-143" />
                              <span data-id="element-144">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}